"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var react_1 = require("react");
var propTypeUtils_1 = require("../../utils/propTypeUtils");
var propTypes = {
    children: propTypeUtils_1.allowedChildren('dt', 'dd')
};
/**
 * A summary list of data. This component is a replacement for a definition list (`dl`) with consistent
 * styling. Only `dt` and `dd` child elements are allowed.
 * The list is displayed two-columned on medium and large screens.
 */
var SummaryList = /** @class */ (function (_super) {
    __extends(SummaryList, _super);
    function SummaryList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SummaryList.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, columns = _a.columns, other = __rest(_a, ["children", "className", "columns"]);
        var componentClassName = classNames('ee_summary-list', className);
        var spanClassNames = [];
        if (columns) {
            if (typeof columns === 'number') {
                spanClassNames.push("span-" + columns);
            }
            else {
                if (columns.regular) {
                    spanClassNames.push("span-" + columns.regular);
                }
                if (columns.medium) {
                    spanClassNames.push("m-span-" + columns.medium);
                }
                if (columns.large) {
                    spanClassNames.push("l-span-" + columns.large);
                }
            }
        }
        var groupClassName = classNames('ee_summary-list__group', spanClassNames.map(function (c) { return "ee_summary-list__group--" + c; }));
        return (React.createElement("dl", __assign({ className: componentClassName }, other), this.getGroups(children).map(function (group, index) { return (React.createElement("div", { className: groupClassName, key: index }, group)); })));
    };
    /**
     * A dl may contain div elements to group dt/dd elements, if needed for
     * styling purposes
     * (see https://html.spec.whatwg.org/multipage/grouping-content.html#the-dl-element)
     *
     * A group consist of one or more dt elements followed by one or more dd
     * elements.
     *
     * This method returns an array of groups, each group being an array of dt/dd
     * elements.
     */
    SummaryList.prototype.getGroups = function (children) {
        // Setting
        //   const groups: React.ReactChild[][] = [];
        // leads to an error in react-docgen:
        //   Error when parsing: Syntax Error: Unexpected token (64:35)
        //
        // Setting it via
        //  const groups: Array<React.ReactChild[]> = [];
        // leads to an error in TSLint:
        //   [64, 19]: Array type using 'Array<T>' is forbidden for simple types. Use 'T[]' instead.
        //
        // Since the first way removes the component from the Styleguide, we use the
        // latter, but have to disable TSLint.
        //
        // tslint:disable-next-line:array-type
        var groups = [];
        var previousType = '';
        var group = [];
        React.Children.forEach(children, function (child) {
            if (React.isValidElement(child)) {
                var type = String(child.type);
                if (type === 'dt' && previousType === 'dd') {
                    groups.push(group);
                    group = [];
                }
                group.push(child);
                previousType = type;
            }
        });
        groups.push(group);
        return groups;
    };
    SummaryList.propTypes = propTypes;
    SummaryList.defaultProps = {
        columns: {
            medium: 2
        }
    };
    return SummaryList;
}(react_1.Component));
exports.SummaryList = SummaryList;
exports.default = SummaryList;
//# sourceMappingURL=SummaryList.js.map
